import React from 'react'
import { Dialog, List, Container } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import MetricsDialogHeader from './metricsDialogHeader'
import { FormattedMessage } from 'react-intl'
import Subscriber from './Subscriber'
import SubscribersDetail from './SubscriberDetail'

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paperWidthSm': {
      minWidth: '600px',
    },
  },
  subTitleStyle: {
    color: '#a8a8a8',
    padding: ' 0 2rem',
    fontSize: 'smaller',
    minWidth: '345px',
    overflow: 'hidden !important',
  },
  flagTitleContainerStyle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    fontWeight: 'bold',
    '& > span:nth-child(1)': {
      color: '#404040',
    },
    '& > span:nth-child(2)': {
      color: '#0073b1',
      paddingLeft: '15px',
    },
  },
  containerStyle: {
    padding: '30px',
  },
  listStyle: {
    maxHeight: '200px',
    overflowY: 'scroll',
    marginTop: '30px',
  },
  headerStyle: {
    height: '80px',
    borderBottom: '1px solid rgba(112, 112, 112, 0.1)',
    paddingBottom: '10px',
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    zIndex: 9,
  },
}))

const FlagsList = ({
  onClose,
  openModal,
  tabDetail,
  title,
  subscribersCount,
  flagSubTitles,
  openSubscribersDetail,
  handleOpenSubscribersDetail,
  subscriberData,
  handleCloseSubscribersDetail,
}) => {
  const classes = useStyles()
  return (
    <Dialog
      open={openModal}
      aria-labelledby="subscribers-list"
      classes={{ root: classes.root }}
    >
      <header className={classes.headerStyle}>
        <MetricsDialogHeader
          title={title}
          iconName="close"
          handleClose={onClose}
        />
        <div className={classes.subTitleStyle}>
          <FormattedMessage
            id="metrics.subscribers"
            values={{ count: subscribersCount }}
          />
        </div>
      </header>

      {flagSubTitles.map((item) =>
        tabDetail['reports'][item.id].length > 0 ? (
          <Container className={classes.containerStyle}>
            <div className={classes.flagTitleContainerStyle}>
              <span>{item.name}</span>
              <span>{`(${tabDetail['reports'][item.id].length} recipients)`}</span>
            </div>
            <List className={classes.listStyle}>
              {tabDetail['reports'][item.id].map(
                (user) =>
                  user && (
                    <Subscriber
                      item={user}
                      handleOpenSubscribersDetail={handleOpenSubscribersDetail}
                    />
                  ),
              )}
            </List>
            <SubscribersDetail
              open={openSubscribersDetail}
              subscriberData={subscriberData}
              handleCloseModal={handleCloseSubscribersDetail}
            />
          </Container>
        ) : null,
      )}
    </Dialog>
  )
}

export default FlagsList
